import { render, staticRenderFns } from "./welfareDetail.vue?vue&type=template&id=420baff9&scoped=true"
import script from "./welfareDetail.vue?vue&type=script&lang=js"
export * from "./welfareDetail.vue?vue&type=script&lang=js"
import style0 from "./welfareDetail.vue?vue&type=style&index=0&id=420baff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420baff9",
  null
  
)

export default component.exports